import api from './axios';

const dashboardQuery = (params = {}) => {
  const search = new URLSearchParams();
  if (params.months != null) search.set('months', String(params.months));
  if (params.days != null) search.set('days', String(params.days));
  if (params.range) search.set('range', params.range);
  if (params.startDate) search.set('startDate', params.startDate);
  if (params.endDate) search.set('endDate', params.endDate);
  const q = search.toString();
  return q ? `?${q}` : '';
};

// Get customer dashboard data (optional: months 3|6|12|24, or range: 'ytd')
export const getCustomerDashboard = async (params = {}) => {
  const response = await api.get(`/dashboard/customer${dashboardQuery(params)}`);
  return response.data;
};

// Get admin dashboard data
export const getAdminDashboard = async (params = {}) => {
  const response = await api.get(`/dashboard/admin${dashboardQuery(params)}`);
  return response.data;
};

// Get employee dashboard data
export const getEmployeeDashboard = async (params = {}) => {
  const response = await api.get(`/dashboard/employee${dashboardQuery(params)}`);
  return response.data;
};

 